module.exports = __webpack_public_path__ + "static/media/cash-for-damaged-cars-home.a1a9ec3d.png";